/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 30/07/13
 * Time: 10:58
 * To change this template use File | Settings | File Templates.
 */


angular.module('FlexyBeautyApp.services').
    factory('Supplier_Resource',["$resource","$location", function ($resource,$location)
    {
        var baseUrl = $location.protocol()  + "://" + $location.host() + ($location.port() && ":" + $location.port())  + "/";
        var  resourceBooking = $resource( baseUrl +'rest/suppliers/:id',{}, {
            query: { method: 'GET', isArray: true },
            get:   { method: 'GET'}

        });
        return resourceBooking;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('Supplier',["Supplier_Resource","SupplierData", function (Supplier_Resource,SupplierData)
    {
        var  Supplier = function (resource)
        {
            this.id = null;
            this.isDeleted = false;
            this.label = null;
            this.lastName = null;
            this.firstName = null;
            this.email = null;
            this.isVerified = false;
            this.phone = null;
            this.password = null;
            this.address1 = null;
            this.address2 = null;
            this.city = null;
            this.postCode = null;
            this.products = [];// generate a local link to products
            this.version = null;
            this.loadObject(resource);
            SupplierData.add(this);
        }
        Supplier.prototype.loadObject = function(object)
        {
            if (object!==undefined && object!=null)
            {
                if (!this.id)
                    this.id = object.id;
                this.isDeleted = object.isDeleted;
                this.label = object.label;
                this.lastName = object.lastName;
                this.firstName = object.firstName;
                this.email = object.email;
                this.isVerified = object.isVerified;
                this.phone = object.phone;
                this.landline = object.landline;
                this.address1 = object.address1;
                this.address2 = object.address2;
                this.city = object.city;
                this.postCode = object.postCode;
                if (object.version)
                    this.version = object.version;
            }
        }
        Supplier.prototype.getObjectResource = function()
        {
            var rsSupplier = new Supplier_Resource();
            rsSupplier.id = this.id;
            rsSupplier.isDeleted = this.isDeleted;
            rsSupplier.label = this.label;
            rsSupplier.firstName = this.firstName;
            rsSupplier.lastName = this.lastName;
            rsSupplier.email = this.email;
            rsSupplier.isVerified = this.isVerified;
            rsSupplier.phone = this.phone;
            rsSupplier.landline = this.landline;
            rsSupplier.address1 = this.address1;
            rsSupplier.address2 = this.address2;
            rsSupplier.city = this.city;
            rsSupplier.postCode = this.postCode;

            return rsSupplier;
        }

        Supplier.prototype.getId = function()
        {
            return this.id;
        }
        Supplier.prototype.getLabel = function()
        {
            return this.firstName + ' ' + this.lastName;
        }
        Supplier.prototype.getPhone = function()
        {
            return this.phone;
        }
        Supplier.prototype.getEmail = function()
        {
            return this.email;
        }
        Supplier.prototype.setId = function(id)
        {
            this.id = id;
        }
        Supplier.prototype.addProduct = function(product)
        {
            var index = this.products.indexOf(product);
            if (index==-1)//Not already there
            {
                this.products.push(product);
            }
        }
        Supplier.prototype.removeProduct = function(product)
        {
            var index = this.products.indexOf(product);
            if (index!=-1)//Found
            {
                this.products.splice(index,1);
            }

        }
        return Supplier;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('SupplierSrv',["$log","Supplier_Resource","UserActionData","Supplier","SupplierData","ServerSrv",
        function ($log,Supplier_Resource,UserActionData,Supplier,SupplierData,ServerSrv)
        {
        var  supplierSrv = {};

        supplierSrv.query = function(successFunction,errorFunction)
        {
            Supplier_Resource.query(
                {}, //params
                function (data) {   //success
                    SupplierData.clear() ;
                    for (var i=0;i< data.length;i++)
                        new Supplier(data[i]);//Auto Add to SupplierData
                    if (successFunction!== undefined)
                        successFunction(SupplierData.indexSuppliers);

                },
                function (data) {   //failure
                    $log.error("Supplier_Resource.query error");
                    $log.error(data);
                    if (errorFunction!== undefined)
                        errorFunction(data);
                });
        };
        supplierSrv.save = function(supplier,successFunction,errorFunction)
        {
            ServerSrv.startSavingProcess(supplierSrv.saveSync, supplier, successFunction, errorFunction);
        };
        supplierSrv.saveSync = function(supplier,successFunction,errorFunction)
        {
            //$timeout (function () {

            var SupplierRes = supplier.getObjectResource();
            SupplierRes.$save({}, //no params
                function (data) {
                    try{
                        supplier.setId(data.id);
                        if (!supplier.version || (data.version && data.version > supplier.version))
                            supplier.version = data.version;
                        //TODO UserActionData.add(data.userAction);
                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {
                    try {
                        if (errorFunction != undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );

            //},2000)
        };
        supplierSrv.remove = function(supplier,successFunction,errorFunction)
        {
            SupplierData.remove(supplier);
            ServerSrv.startSavingProcess(supplierSrv.removeSync, supplier, successFunction, errorFunction);
        };
        supplierSrv.removeSync =  function(supplier,successFunction,errorFunction)
        {
            //$timeout (function () {

            var supplierSrv = new Supplier_Resource();
            supplierSrv.$remove({id:supplier.getId()}, //params : id
                function (data) {
                    try{
                        //TODO UserActionData.add(data.userAction);
                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        if (errorFunction != undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );

            //},2000)
        };
        supplierSrv.restore = function(supplier,successFunction,errorFunction)
        {
            SupplierData.restore(supplier);
            ServerSrv.startSavingProcess(supplierSrv.restoreSync, supplier, successFunction, errorFunction);
        };
        supplierSrv.restoreSync = function(supplier,successFunction,errorFunction)
        {
            //$timeout (function () {

            var SupplierRes = supplier.getObjectResource();
            SupplierRes.$save({}, //no params
                function (data) {
                    try{
                        supplier.setId(data.id);
                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        if (errorFunction != undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );

            //},2000)
        };
        supplierSrv.get =  function(id,successFunction,errorFunction)
        {
            Supplier_Resource.get(
                {id:id}, //params
                function (supplierResource) {
                    if (successFunction!=undefined)
                        successFunction(new Supplier(supplierResource));
                },
                function (data) {
                    if (errorFunction !=undefined)
                        errorFunction(data);
                });
        };

        supplierSrv.updateLocally =  function(id,resource)
        {
            var supplier =  SupplierData.getById(id)
            if (supplier!=null)
                supplier.loadObject(resource);
            return supplier;
        };
        supplierSrv.removeLocally =  function(id,resource)
        {
            var supplier =  SupplierData.getById(id)
            if (supplier!=null)
                SupplierData.remove(supplier);
            return supplier;
        };
        supplierSrv.addLocally =  function(id,resource)
        {
            var supplier =  SupplierData.getById(id);
            if (supplier!=null) //check if resource already exist inside index (current action could be a 'cancel')
            {
                supplier.loadObject(resource);
                SupplierData.add(supplier);
            }
            else
            {
                supplier = new Supplier(resource);
                supplier.id =id;
            }
            return supplier;
        };

        return supplierSrv;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('SupplierData',["$filter", function ($filter)
    {
        var  custDataSrv =
        {
            indexSuppliers : [],
            activeSuppliers : [],
            deletedSuppliers : []//deleted items
        };
        custDataSrv.getById =  function(supplierId)
        {
            for (var i=0;i<this.indexSuppliers.length;i++)
                if (this.indexSuppliers[i].getId()==supplierId)
                    return this.indexSuppliers[i];
            return null;
        }
        custDataSrv.getByIndex =  function(index)
        {
            if (index>=0 && index <this.indexSuppliers.length)
                return this.indexSuppliers[index];
            return null;
        }
        custDataSrv.getIndexOf =  function(supplier)
        {
            if (supplier)
                return this.indexSuppliers.indexOf(supplier);
            return -1;
        }

        custDataSrv.add =  function(supplier)
        {
            var supplierArray = this.activeSuppliers;
            if (supplier.isDeleted)
                supplierArray =  this.deletedSuppliers;
            var index =  this.indexSuppliers.indexOf(supplier);
            if (index!=-1)
            {
                var realIndex = supplierArray.indexOf(supplier);
                if (realIndex==-1)
                    supplierArray.push(supplier);
            }
            else
            {
                index = this.indexSuppliers.length
                this.indexSuppliers.push(supplier);
                supplierArray.push(supplier);
            }
            return index;
        }        
        custDataSrv.remove =  function(supplier)
        {
            var index =  this.activeSuppliers.indexOf(supplier);
            if (index!=-1)
            {
                this.activeSuppliers.splice(index, 1);
                this.deletedSuppliers.push(supplier)
                supplier.isDeleted=true;
            }
        }
        custDataSrv.restore =  function(supplier)
        {
            var index =  this.deletedSuppliers.indexOf(supplier);
            if (index!=-1)
            {
                this.deletedSuppliers.splice(index, 1);
                this.activeSuppliers.push(supplier);
                supplier.isDeleted=false;
            }
        }
        custDataSrv.clear =  function()
        {
            this.indexSuppliers = [];
            this.activeSuppliers = [];
            this.deletedSuppliers = [];
        }
        custDataSrv.sort =  function()
        {
            this.activeSuppliers = $filter('orderBy')(this.activeSuppliers,'label', false);
            this.deletedSuppliers = $filter('orderBy')(this.deletedSuppliers,'label', false);
        }

        custDataSrv.getActiveList =  function()
        {
            return this.activeSuppliers;
        }
        custDataSrv.getDeletedList =  function()
        {
            return this.deletedSuppliers;
        }
        return   custDataSrv;
    }
    ]);


// WEBPACK FOOTER //
// ./js/services/models/Supplier.js